/**
 * Reauth-on-401/403 guard (lesson from PitchPricer's reauthOn403). A 401/403 from the
 * API means the session is missing/expired/rejected; bounce ONCE to pick up a fresh
 * session instead of 403-storming. Two guards: a per-page-load flag and a sessionStorage
 * timestamp so we never enter a reload loop.
 */
const REAUTH_KEY = 'fluentai_reauth_at';
const MIN_INTERVAL_MS = 10_000;

let handledThisLoad = false;

/** Pure decision (testable): may we trigger a reauth bounce now? */
export function shouldReauth(now: number, lastAt: number, alreadyHandled: boolean): boolean {
  if (alreadyHandled) return false;
  return now - lastAt >= MIN_INTERVAL_MS;
}

/** Side-effecting: bounce through the auth gate once to refresh the session. */
export function handleAuthExpired(): void {
  const lastAt = Number(sessionStorage.getItem(REAUTH_KEY) ?? '0');
  if (!shouldReauth(Date.now(), lastAt, handledThisLoad)) return;
  handledThisLoad = true;
  sessionStorage.setItem(REAUTH_KEY, String(Date.now()));
  // With edge-auth (Lambda@Edge) a reload re-runs the viewer-request gate and mints a
  // fresh cookie; with Hosted UI, redirect to the login endpoint instead.
  window.location.reload();
}

export const AUTH_EXPIRED = 'AUTH_EXPIRED';
